module.exports = __webpack_public_path__ + "img/telegram.dddaf391.png";